import React, { useEffect, useState } from "react";

import CloseIcon from "@mui/icons-material/Close";
import GvUploadImageButton from "../../../components/GvUploadImageButton/GvUploadImageButton";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
import { CREATE_BOOKING_TYPE, MODALS } from "../../../config/params";
import { ModalHeader } from "../../../styles/styledComponents/Header.styled";
import { PAGES_PATH } from "../../../navigation/params";
import { PetFormType } from "../../../services/pet-create/pet-create.schema";
import { PetNewOneForm } from "../../forms";
import { Typography } from "@mui/material";
import { useAppointmentStore } from "../../../hooks/redux-hooks/appointment-store/appointment.store";
import { useGTM } from "../../../hooks/useGTM";
import { useModal } from "../../../context/ModalContext";
import { useNavigate } from "react-router-dom";
import { usePetCreate } from
  "../../../services/pet-create/pet-create.service";
import { usePetList } from "../../../services/pet-list/pet-list.service";
import { userActivityLogger } from "../../../utils/mixpanel";
import { useBookingAppointmentTypeStore } from "../../../hooks";

interface INewPetContainer{
  setActiveStep?:(step:number)=>void
}
const NewPetContainer: React.FC<INewPetContainer> = ({ setActiveStep }) => {
  const [fileImage, setFileImage] = useState<File>();
  const { addAPet, petCreated, error } = usePetCreate();
  const { setSelectedPets }= useAppointmentStore();
  const { petsActive: petList } = usePetList();
  const { setDefaultBookingType, bookingAppointmentType } = useBookingAppointmentTypeStore();


  const { dispatchEvent } = useGTM();
  const { openModal, closeModal, params }=useModal();
  const navigate = useNavigate();
  const redirectOnSave = Boolean(params?.redirectOnSave);

  const onChangeUploadImage = (file: any) => setFileImage(file);

  const handleSubmitStepOne = (dataForm: PetFormType) => {
    addAPet(dataForm, fileImage as File);
    dispatchEvent({
      eventName: "gv_add_a_pet_next",
    });
    userActivityLogger(MIXPANEL_EVENTS.ADD_PET_TRIGER, {
      user_type_new: (petList?.length ?? 0) < 1 ? "no" : "yes", pet_name: dataForm?.name });
  };

  const handleCancel = () => {
    setDefaultBookingType();
    closeModal();
  };

  useEffect(() => {
    const isUrgentFlow = bookingAppointmentType === CREATE_BOOKING_TYPE.URGENT_BOOKING;

    if (petCreated) {
      if (redirectOnSave) {
        userActivityLogger(MIXPANEL_EVENTS.ADD_PET_SUCCESS, {
          user_type_new: (petList?.length ?? 0) < 1 ? "no" : "yes",
          pet_name: petCreated.pet.name,
        });
        closeModal();
        navigate(
          `${PAGES_PATH.PET_CARE}?id=${petCreated.pet.id}&category=TotalCare_Plan`,
        );
        return;
      }
      if ( petList?.length === 1) {
        if (isUrgentFlow) {
          userActivityLogger(MIXPANEL_EVENTS.URGENT_VISIT_SELECT_PET, {
            appointment_category: "urgent",
            pet_name: petList[0].name,
            referred_from: "new-pet_added",
          });
          openModal(MODALS.URGENT_VISIT_MODAL);
        } else {
          setSelectedPets(petList);
          userActivityLogger(MIXPANEL_EVENTS.BOOK_A_VISIT_SELECT_PET, { no_of_pets: 1, pet_name: petList[0].name,
            owner_type: petList?.length==1?"single_pet":"multipet", referred_from: "new-pet_added",
            appt_type: bookingAppointmentType === CREATE_BOOKING_TYPE.DROPOFF_BOOKING ? "drop_off" : "in_room_visit",
          });
          openModal(MODALS.UPDATED_BOOK_A_VISIT_MODAL);
        }
      } else {
        if (isUrgentFlow) {
          userActivityLogger(MIXPANEL_EVENTS.URGENT_VISIT_SELECT_PET, {
            appointment_category: "urgent",
            pet_name: petCreated.pet.name,
            referred_from: "new-pet_added",
          });
          openModal(MODALS.URGENT_VISIT_MODAL);
        } else {
          if (petList?.length && (petList?.length > 1)) {
            setDefaultBookingType();
          }
          handleCancel();
        }
      }
      userActivityLogger(MIXPANEL_EVENTS.ADD_PET_SUCCESS, {
        user_type_new: (petList?.length ?? 0) < 1 ? "no" : "yes",
        pet_name: petCreated.pet.name,
      });
    }
    if (error) {
      userActivityLogger(MIXPANEL_EVENTS.ADD_PET_FAILURE, {
        user_type_new: (petList?.length ?? 0) < 1 ? "no" : "yes",
        error_message: error.graphQLErrors[0].message,

      });
    }
  }, [petCreated, error, redirectOnSave]);


  return (
    <div className="flex flex-col grow overflow-y-auto pr-1 ">
      <div className="flex justify-end h-[5%] 2xl:h-[7%] !sticky top-2">
        <p className="cursor-pointer" onClick={handleCancel}><CloseIcon className="mr-4 mt-2" /></p>
      </div>
      <div className="text-center mb-[1.2rem]">
        <ModalHeader className="text-light-black ">Add Your Pet</ModalHeader>
        <Typography className="!text-base !text-light-black tracking-wide !mb-[1.4rem]">
          Help us get to know your furry friend</Typography>
        <GvUploadImageButton
          id="signUpPetUploadImageButton"
          onChange={onChangeUploadImage}
          hideUploadButton={true}
        />
      </div>
      <div className={"flex flex-col grow shrink "}>
        <PetNewOneForm onSubmit={handleSubmitStepOne} />
      </div>
    </div>

  );
};

export default NewPetContainer;
